export const getStars = (stars = []) => {
  const ratings = [...Array(5)].map((_, i) => stars[i] || 0);
  const amount = ratings.reduce((sum, count) => sum + count, 0);

  return { ratings, amount };
};


export const calculateReviews = (ratings, amount) => {
  const count = ratings.reduce((sum, num, index) => sum + num * (index + 1), 0);
  return count === 0 ? 0 : count / amount;
};